<div class="wrapper-footer-landing" [ngClass]="activeFooterClass">
  <div class="wrapper-content-footer-landing">
    <div class="footer-landing-left">
      <img src="../../../../assets/images/landing/logo-footer.svg" alt="">
      <span>Our vision is to provide convenience and help increase your sales business.</span>
      <div class="store-footer">
        <a href="https://apps.apple.com/rs/app/moj-rodjendan/id6741870230" target="_blank"><img src="../../../../assets/images/landing/app-store.png" alt=""></a>
        <a href="https://play.google.com/store/apps/details?id=com.mojrodjendan.app" target="_blank"><img src="../../../../assets/images/landing/google-play-store.png" alt=""></a>
      </div>
    </div>
    <div class="footer-landing-right">
      <div class="links-pages">
        <h3>Linkovi</h3>
        <span [routerLink]="[PAGES_AND_PATHS.landingAboutUs.pagePath]" routerLinkActive="active">O nama</span>
        <span [routerLink]="[PAGES_AND_PATHS.landingBlog.pagePath]" routerLinkActive="active">Blog</span>
        <span [routerLink]="[PAGES_AND_PATHS.landingForBusinesses.pagePath]" routerLinkActive="active">Za biznise</span>
        <span [routerLink]="[PAGES_AND_PATHS.landingContact.pagePath]" routerLinkActive="active">Kontakt</span>
      </div>
      <div class="social-media">
        <h3>Društvene mreže</h3>
        <div class="wrapper-social-media-box">
          <div class="social-media-box social-media-box--1">
            <img src="../../../../assets/icons/landing/instagram-footer.svg" alt="">
          </div>
          <div class="social-media-box social-media-box--2">
            <img src="../../../../assets/icons/landing/facebook-footer.svg" alt="">
          </div>
          <div class="social-media-box social-media-box--3">
            <img src="../../../../assets/icons/landing/tiktok-footer.svg" alt="">
          </div>
          <div class="social-media-box social-media-box--4">
            <img src="../../../../assets/icons/landing/icon-star-blue.svg" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="wrapper-links-footer-bottom">
    <span>©2025 Moj Rođendan. All rights reserved</span>
    <div class="right-footer-bottom">
      <span [routerLink]="[PAGES_AND_PATHS.privacyPolicy.pagePath]">Politika privatnosti</span>
      <span [routerLink]="[PAGES_AND_PATHS.termsOfUse.pagePath]">Uslovi korišćenja</span>
    </div>
  </div>
</div>

